/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Boundary_New_VersionInputs */

const nl_common_error_boundary_new_version = /** @type {(inputs: Common_Error_Boundary_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is een nieuwe versie van Beweegbaas. Ververs de pagina om verder te gaan.`)
};

/**

* @param {Common_Error_Boundary_New_VersionInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_error_boundary_new_version = /** @type {((inputs?: Common_Error_Boundary_New_VersionInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Boundary_New_VersionInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_error_boundary_new_version(inputs)
});
export { common_error_boundary_new_version as "common.error_boundary_new_version" }